import React from 'react';
import { 
  HomeFilled,
  SearchFilled,
  HeartFilled,
  PersonFilled,
  BookFilled,
  WeatherSunnyFilled,
  WeatherMoonFilled,
  Wifi1Filled,
  WifiOffFilled,
  ChevronLeftFilled,
  ChevronRightFilled,
  SettingsFilled,
  AlertFilled,
  AddFilled,
  DismissFilled,
  CheckmarkFilled,
  ErrorCircleFilled,
  InfoFilled,
  ArrowClockwiseFilled
} from '@fluentui/react-icons';

interface IconProps {
  size?: number;
  color?: string;
  className?: string;
}

// 导航图标 - 使用Fluent Icons Filled样式
export const HomeIcon: React.FC<IconProps> = ({ size = 24, color, className }) => (
  <HomeFilled 
    style={{ 
      fontSize: `${size}px`, 
      color: color || 'currentColor',
      width: `${size}px`,
      height: `${size}px`
    }} 
    className={className} 
  />
);

export const SearchIcon: React.FC<IconProps> = ({ size = 24, color, className }) => (
  <SearchFilled 
    style={{ 
      fontSize: `${size}px`, 
      color: color || 'currentColor',
      width: `${size}px`,
      height: `${size}px`
    }} 
    className={className} 
  />
);

export const HeartIcon: React.FC<IconProps> = ({ size = 24, color, className }) => (
  <HeartFilled 
    style={{ 
      fontSize: `${size}px`, 
      color: color || 'currentColor',
      width: `${size}px`,
      height: `${size}px`
    }} 
    className={className} 
  />
);

export const UserIcon: React.FC<IconProps> = ({ size = 24, color, className }) => (
  <PersonFilled 
    style={{ 
      fontSize: `${size}px`, 
      color: color || 'currentColor',
      width: `${size}px`,
      height: `${size}px`
    }} 
    className={className} 
  />
);

export const BookIcon: React.FC<IconProps> = ({ size = 24, color, className }) => (
  <BookFilled 
    style={{ 
      fontSize: `${size}px`, 
      color: color || 'currentColor',
      width: `${size}px`,
      height: `${size}px`
    }} 
    className={className} 
  />
);

// 主题切换图标
export const SunIcon: React.FC<IconProps> = ({ size = 20, color, className }) => (
  <WeatherSunnyFilled 
    style={{ 
      fontSize: `${size}px`, 
      color: color || 'currentColor',
      width: `${size}px`,
      height: `${size}px`
    }} 
    className={className} 
  />
);

export const MoonIcon: React.FC<IconProps> = ({ size = 20, color, className }) => (
  <WeatherMoonFilled 
    style={{ 
      fontSize: `${size}px`, 
      color: color || 'currentColor',
      width: `${size}px`,
      height: `${size}px`
    }} 
    className={className} 
  />
);

// 网络状态图标
export const WifiIcon: React.FC<IconProps> = ({ size = 20, color, className }) => (
  <Wifi1Filled 
    style={{ 
      fontSize: `${size}px`, 
      color: color || 'currentColor',
      width: `${size}px`,
      height: `${size}px`
    }} 
    className={className} 
  />
);

export const WifiOffIcon: React.FC<IconProps> = ({ size = 20, color, className }) => (
  <WifiOffFilled 
    style={{ 
      fontSize: `${size}px`, 
      color: color || 'currentColor',
      width: `${size}px`,
      height: `${size}px`
    }} 
    className={className} 
  />
);

// 导航图标
export const BackIcon: React.FC<IconProps> = ({ size = 20, color, className }) => (
  <ChevronLeftFilled 
    style={{ 
      fontSize: `${size}px`, 
      color: color || 'currentColor',
      width: `${size}px`,
      height: `${size}px`
    }} 
    className={className} 
  />
);

export const ChevronRightIcon: React.FC<IconProps> = ({ size = 20, color, className }) => (
  <ChevronRightFilled 
    style={{ 
      fontSize: `${size}px`, 
      color: color || 'currentColor',
      width: `${size}px`,
      height: `${size}px`
    }} 
    className={className} 
  />
);

export const SettingsIcon: React.FC<IconProps> = ({ size = 20, color, className }) => (
  <SettingsFilled 
    style={{ 
      fontSize: `${size}px`, 
      color: color || 'currentColor',
      width: `${size}px`,
      height: `${size}px`
    }} 
    className={className} 
  />
);

export const BellIcon: React.FC<IconProps> = ({ size = 20, color, className }) => (
  <AlertFilled 
    style={{ 
      fontSize: `${size}px`, 
      color: color || 'currentColor',
      width: `${size}px`,
      height: `${size}px`
    }} 
    className={className} 
  />
);

// 通用图标
export const PlusIcon: React.FC<IconProps> = ({ size = 20, color, className }) => (
  <AddFilled 
    style={{ 
      fontSize: `${size}px`, 
      color: color || 'currentColor',
      width: `${size}px`,
      height: `${size}px`
    }} 
    className={className} 
  />
);

export const CloseIcon: React.FC<IconProps> = ({ size = 20, color, className }) => (
  <DismissFilled 
    style={{ 
      fontSize: `${size}px`, 
      color: color || 'currentColor',
      width: `${size}px`,
      height: `${size}px`
    }} 
    className={className} 
  />
);

// 刷新图标
export const RefreshIcon: React.FC<IconProps> = ({ size = 20, color, className }) => (
  <ArrowClockwiseFilled
    style={{
      fontSize: `${size}px`,
      color: color || 'currentColor',
      width: `${size}px`,
      height: `${size}px`
    }}
    className={className}
  />
);

export const CheckIcon: React.FC<IconProps> = ({ size = 20, color, className }) => (
  <CheckmarkFilled 
    style={{ 
      fontSize: `${size}px`, 
      color: color || 'currentColor',
      width: `${size}px`,
      height: `${size}px`
    }} 
    className={className} 
  />
);

// 状态图标
export const AlertIcon: React.FC<IconProps> = ({ size = 20, color, className }) => (
  <ErrorCircleFilled 
    style={{ 
      fontSize: `${size}px`, 
      color: color || 'currentColor',
      width: `${size}px`,
      height: `${size}px`
    }} 
    className={className} 
  />
);

export const InfoIcon: React.FC<IconProps> = ({ size = 20, color, className }) => (
  <InfoFilled 
    style={{ 
      fontSize: `${size}px`, 
      color: color || 'currentColor',
      width: `${size}px`,
      height: `${size}px`
    }} 
    className={className} 
  />
);

export const LoadingIcon: React.FC<IconProps> = ({ size = 20, color, className }) => (
  <ArrowClockwiseFilled 
    style={{ 
      fontSize: `${size}px`, 
      color: color || 'currentColor',
      width: `${size}px`,
      height: `${size}px`
    }} 
    className={`animate-spin ${className}`} 
  />
);

// 网络状态指示器组件
interface NetworkStatusIconProps extends IconProps {
  isOnline: boolean;
}

export const NetworkStatusIcon: React.FC<NetworkStatusIconProps> = ({ 
  isOnline, 
  size = 16, 
  className 
}) => {
  return isOnline ? (
    <WifiIcon 
      size={size} 
      color="#34C759" 
      className={className} 
    />
  ) : (
    <WifiOffIcon 
      size={size} 
      color="#FF3B30" 
      className={className} 
    />
  );
};

// 主题切换图标组件
interface ThemeToggleIconProps extends IconProps {
  isDark: boolean;
}

export const ThemeToggleIcon: React.FC<ThemeToggleIconProps> = ({ 
  isDark, 
  size = 20, 
  className 
}) => {
  return isDark ? (
    <SunIcon size={size} className={className} />
  ) : (
    <MoonIcon size={size} className={className} />
  );
};